<template>
  <el-dialog
    title="查看日志"
    width="1300px"
    :visible.sync="dialogVisible"
    :before-close="close"
    :close-on-click-modal="false"
    append-to-body
    top="5vh"
    @open="open"
    @closed="closed"
  >
    <Log v-if="visi" :agreement-code="agreementCode" />
  </el-dialog>
</template>

<script>
import { mapState } from 'vuex'
import Log from '../../../views/log/protocol-reporting-log/index.vue'
export default {
  name: 'TaskCenter',
  components: { Log },
  props: {

  },
  data() {
    return {
      visi: false

    }
  },
  computed: {
    ...mapState({
      dialogVisible: state => state.user.logDialogVisi,
      agreementCode: state => state.user.agreementCode
    })
  },
  watch: {

  },
  methods: {
    close() {
      this.$store.commit('user/SET_LOG_DIALOG_VISI', false)
    },
    open() {
      this.visi = true
    },
    closed() {
      this.visi = false
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapping{
  font-size: 14px;
  color: #757575;
  margin-bottom: 10px;
  padding-left: 80px;
}
</style>
<style >
.ExceptionDialogBox .el-carousel__button{
  height: 10px;
  width: 10px;
  border-radius: 50%;
  border: 1px solid #7d7d7d;

}
.ExceptionDialogBox .el-carousel__indicator.is-active button{
  background: #1890ff;
  border-color: #1890ff;
}

</style>
